export function delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms))
}

export function nowTimestampSeconds(): number {
    return Date.now() / 1000 | 0
}
